// extracted by mini-css-extract-plugin
export default {"wrapper":"AppName_wrapper__VvStu","appLogo":"AppName_appLogo__aYPfy","appName":"AppName_appName__7rCPx"};